export default {
    PASTE: "Вставить",
    METHODS: "Методы",
    COPY: "Копировать",
    DELETE: "Удалить",
    OPEN_TABLE: "Открыть таблицу"
};
